import { Organisation } from "../../AppDataProvider/types";

export function getCurrencyDisplay(
  value: number,
  currency: Organisation["currency"],
  locale: string,
) {
  return value.toLocaleString(locale, {
    currency,
    style: "currency",
  });
}
